import ColorService from '@services/color'

type InitialVariablesArguments = {
  colors: string[]
}

export const getInitialVariables = (data: InitialVariablesArguments) => {
  return {
    '--font-size': '14px',
    '--animation-speed': '300ms',
    '--opacity': '.7',
    '--border-radius1': '12px',
    '--border-radius2': '10px',
    '--box-shadow1': '0 2px 5px rgba(0, 0, 0, .08), 0 1px 1px rgba(0, 0, 0, .12), 0 0 0 1px rgba(70, 118, 217, .16)',
    '--box-shadow2': '0 2px 5px rgba(79, 79, 79, .08), 0 1px 1px rgba(0, 0, 0, .12), 0 0 0 1px var(--color1)',
    '--color1-rgb': ColorService(data.colors[0]).toRGBAArray().join(','),
    '--color2-rgb': ColorService(data.colors[1]).toRGBAArray().join(','),
    '--color6': '#7b8895',
    '--success': '#74ba00',
    '--error': '#ff3939'
  }
}
